import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { Combobox, Tooltip, Icon } from '@salesforce/design-system-react';
import { RangeSlider } from '../../common/components';

import { sendEvent } from '../../utilities/instrumentation';

import './DataFilter.scss';

export class DataFilter extends Component {
  renderEmailTypeTooltip() {
    const { formatMessage } = this.props.intl;
    const p1 = formatMessage({ id: 'DataFilter.emailType.tooltip.p1' });
    const p2 = formatMessage({ id: 'DataFilter.emailType.tooltip.p2' });
    const finalText = (
      <div>
        <p className="slds-m-bottom_small">{p1}</p>
        <p>{p2}</p>
      </div>
    );
    return (
      <Tooltip align="bottom right" content={finalText}>
        <button className="slds-button tooltip-trigger-button">
          <Icon
            assistiveText={{ label: 'More Information' }}
            category="utility"
            name="info"
            size="x-small"
            position="relative"
          />
        </button>
      </Tooltip>
    );
  }

  renderRangeTooltip() {
    const { formatMessage } = this.props.intl;
    const text = formatMessage({ id: 'DataFilter.frequencyRange.tooltip' });
    return (
      <Tooltip align="bottom right" content={text}>
        <button className="slds-button tooltip-trigger-button">
          <Icon
            assistiveText={{ label: 'More Information' }}
            category="utility"
            name="info"
            size="x-small"
            position="relative"
          />
        </button>
      </Tooltip>
    );
  }

  calculateRange() {
    const { rangeStart, rangeEnd, frequencyMax } = this.props;
    let range = [];
    range[0] = rangeStart ? rangeStart : 1;
    range[1] = rangeEnd ? rangeEnd : frequencyMax;
    return range;
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { lookback, emailType, frequencyMax } = this.props;
    const lookbackStr = lookback.toString();
    const lookbackOptions = {
      '30': {
        label: formatMessage({ id: 'DataFilter.lookback.30' }),
        id: '30'
      },
      '60': {
        label: formatMessage({ id: 'DataFilter.lookback.60' }),
        id: '60'
      },
      '90': {
        label: formatMessage({ id: 'DataFilter.lookback.90' }),
        id: '90'
      }
    };
    const emailTypeOptions = {
      commercial: {
        label: formatMessage({ id: 'DataFilter.emailType.commercial' }),
        id: 'commercial'
      },
      all_emails: {
        label: formatMessage({ id: 'DataFilter.emailType.all' }),
        id: 'all_emails'
      }
    };

    return (
      <div className="data-filter">
        <h1 className="section-title">
          <FormattedMessage id="DataFilter.title" />
        </h1>
        <div className="slds-grid slds-gutters_direct">
          <div className="selection-container slds-col slds-size_1-of-2">
            <h2 className="input-label">
              <FormattedMessage id="DataFilter.lookback.title" />
            </h2>
            <Combobox
              id="lookbackValue"
              events={{
                onSelect: (event, data) => {
                  if (this.props.action) {
                    this.props.action('onSelect')(
                      event,
                      ...Object.keys(data).map(key => data[key])
                    );
                  }
                  if (data.selection.length) {
                    this.props.actions.updateDataFilter({
                      lookback: Number(data.selection[0].id),
                      rangeStart: null,
                      rangeEnd: null
                    });
                    sendEvent(
                      'changeSelection',
                      'lookbackDays',
                      data.selection[0].id
                    );
                  }
                }
              }}
              labels={{
                placeholder: formatMessage({
                  id: 'DataFilter.lookback.placeholder'
                })
              }}
              options={Object.values(lookbackOptions)}
              value={lookbackStr}
              selection={[lookbackOptions[lookbackStr]]}
              variant="readonly"
            />
          </div>
          <div className="selection-container slds-col slds-size_1-of-2">
            <h2 className="input-label">
              <FormattedMessage
                id="DataFilter.emailType.title"
                values={{
                  tooltip: this.renderEmailTypeTooltip()
                }}
              />
            </h2>
            <Combobox
              id="emailTypeValue"
              events={{
                onSelect: (event, data) => {
                  if (this.props.action) {
                    this.props.action('onSelect')(
                      event,
                      ...Object.keys(data).map(key => data[key])
                    );
                  }
                  if (data.selection.length) {
                    this.props.actions.updateDataFilter({
                      emailType: data.selection[0].id,
                      rangeStart: null,
                      rangeEnd: null
                    });
                    sendEvent(
                      'changeSelection',
                      'emailType',
                      data.selection[0].id
                    );
                  }
                }
              }}
              labels={{
                placeholder: formatMessage({
                  id: 'DataFilter.emailType.placeholder'
                })
              }}
              options={Object.values(emailTypeOptions)}
              value={emailType}
              selection={[emailTypeOptions[emailType]]}
              variant="readonly"
            />
          </div>
        </div>
        <div className="range-selector">
          <h2 className="input-label">
            <FormattedMessage
              id="DataFilter.frequencyRange.title"
              values={{
                tooltip: this.renderRangeTooltip()
              }}
            />
          </h2>
          <RangeSlider
            min={1}
            max={frequencyMax}
            range={this.calculateRange()}
            actions={this.props.actions}
          />
        </div>
      </div>
    );
  }
}

DataFilter.propTypes = {
  children: PropTypes.element,
  location: PropTypes.object,
  lookback: PropTypes.number,
  emailType: PropTypes.string,
  frequencyMax: PropTypes.number,
  rangeStart: PropTypes.number,
  rangeEnd: PropTypes.number,
  intl: intlShape.isRequired
};

export default injectIntl(DataFilter);
